import axiosInstance from "@/lib/axiosInterceptor";
import { ResetReqFormData } from "@/modules/Auth/types/resetReqFormData";
import { Result } from "types/result";

interface Data {
    email: string;
    message: string;
}

export const resetReqFn = async (formData: ResetReqFormData): Promise<Result<Data>> => {
    try {
        const response = await axiosInstance.post(
            `${process.env.NEXT_PUBLIC_ACCOUNT_SERVER_URL}/auth/request-password-reset`,
            formData,
        );
        return {
            data: response.data,
            error: null,
        };
    } catch (e: any) {
        return {
            data: null,
            error: {
                messageKey: e.response.data.response.messageKey,
                message: e.response.data.response.message || e.message,
            },
        };
    }
};
